export class ContactChannelExplanationService {
  private _isOpen: boolean;

  constructor() {
    this._isOpen = false;
  }

  get isOpen(): boolean {
    return this._isOpen;
  }

  toggleOpen(state: boolean) {
    this._isOpen = state;
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-notification-settings/src/services/contact_channel_explanation_service.ts